import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';

import { AppState } from '../../store/states/app.state';
import { UserState } from '../../store/states/user.state';
import { StoreName } from '../../store/definitions/store.constants';
import { UserType } from '../../permissions/definitions/permissions.enums';
import { StorageService } from '../../services/storage/storage.service';
import { PO_PERMISSIONS } from '../components/purchase-order-detail/purchase-order.constants';

const FH_PERMISSIONS = [
  PO_PERMISSIONS.KAM_CREATOR,
  PO_PERMISSIONS.FINANCE_APPROVER,
  PO_PERMISSIONS.BUSINESS_APPROVER,
] as const;

@Injectable()
export class FinancialHubAccessGuard implements CanActivate {
  constructor(
    private readonly store: Store<AppState>,
    private readonly router: Router,
    private readonly storageService: StorageService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(StoreName.user),
      take(1),
      map((userState: UserState) => {
        const user: UserState = Object.keys(userState).length
          ? userState
          : this.storageService.getUserAction() as unknown as UserState;

        if (user.user_type === UserType.admin) return true;

        const slugs = (user.modules || []).map(m => m.slug);
        const hasAccess = FH_PERMISSIONS.some(p => slugs.includes(p));

        if (!hasAccess) this.router.navigate(['/account']);
        return hasAccess;
      })
    );
  }
}
